import { GET_AUTH } from "../actions/type";

const initialState = {
  permission: undefined,
};

const authReducers = (state = initialState, action) => {
  switch (action.type) {
    case GET_AUTH: {
      return {
        ...state,
        permission: action.payload,
      };
    }


    default:
      return state;
  }
};

export default authReducers;
